<template>
  <v-container>

    <v-card :class="{'elevation-2 py-10 px-4 mb-8': $vuetify.breakpoint.smAndUp, 'elevation-0 rounded-0 py-10 mb-0': $vuetify.breakpoint.xsOnly}">
      <NotificationReview :is-approval="false"/>
<!--      <TestNotification/>-->
    </v-card>

    <v-row :class="{'pt-10 px-3 pb-6': $vuetify.breakpoint.xsOnly}">
      <v-col lg="12" :class="{'pt-0 d-flex justify-space-between': $vuetify.breakpoint.smAndUp, 'pt-0 d-flex flex-column-reverse': $vuetify.breakpoint.xsOnly}">
        <AdsButton
          icon="delete"
          button-text="Discard"
          :id="$vuetify.breakpoint.xs ? 'discardButton' : null"
          secondary
          :class="{'mt-3': $vuetify.breakpoint.xsOnly}"
          @click="showDeleteDialog"
        />
        <div :class="{'pt-0 d-flex justify-end': $vuetify.breakpoint.smAndUp, 'pt-0 d-flex flex-column-reverse': $vuetify.breakpoint.xsOnly}">
          <AdsButton
            button-text="Save & Close"
            tertiary
            @click="saveAsDraft"
            :class="{'mr-3': $vuetify.breakpoint.smAndUp, 'mt-3': $vuetify.breakpoint.xsOnly}"
            style="height: 52px;"
          />
          <AdsButton
            :loading="$store.getters.sendingForApproval"
            icon="upload"
            button-text="Send for approval"
            @click="submitForApproval"
          />
        </div>
      </v-col>
    </v-row>
    <DiscardDialog v-model="deleteDialog" :delete-item="deleteItem" :show-delete-dialog="showDeleteDialog"/>
  </v-container>
</template>

<script>
import {QPLUS_AUDIENCE} from '@/static/data';
import {AdsButton} from '@nswdoe/doe-ui-core';
import DiscardDialog from "@/components/DiscardDialog";
import NotificationReview from "@/components/NotificationReview";
// import TestNotification from "@/components/TestNotification";

export default {
  name: 'notificationStepFour',
  components: {
    NotificationReview,
    DiscardDialog,
    AdsButton,
  },
  data: () => ({
    audienceOptions: QPLUS_AUDIENCE,
    valid: true,
    deleteDialog: false,
  }),
  methods: {
    showDeleteDialog() {
      this.deleteDialog = !this.deleteDialog;
    },
    deleteItem() {
      this.$store.dispatch("deleteNotification", this.$store.getters.currentNotification.draftId)
        .finally(() => {
          this.deleteDialog = false;
          this.$store.commit('setCreateMode', false);
          this.$router.push({name: "notifications"});
        });
    },
    submitForApproval() {
      this.$emit('progress');
    },
    saveAsDraft() {
      this.$store.commit('setAlert', 'draft');
      this.$store.commit('setShowAlert', true);
      setTimeout(() => {
        this.$store.commit('setShowAlert', false);
        this.$store.commit('setAlert', '');
      }, 2000);
      this.$emit('close');
    }
  }
};
</script>

<style scoped>
.light-opacity {
  opacity: 0.6;
}

.test-notification {
  border-radius: 4px;
  background-color: #F5F5F5;
}

.action-alignment {
  padding-left: 24px;
  padding-right: 24px;
}

.testButton {
  border: 2px solid #041E42 !important;
}

.theme--light.v-btn.v-btn--disabled.v-btn--has-bg {
  border: none !important;
}
</style>
